'use client'

import './not-found.scss'

import { useTranslations } from 'next-intl'

import { Container } from '@/src/shared/ui/Container'

export default function Error() {
  const t = useTranslations('NotFoundPage')

  return (
    <div className="not-found-page">
      <Container>
        <div className="not-found-page__box">
          <h1 className="not-found-page__title">{t('title')}</h1>
          <p className="not-found-page__text">{t('description')}</p>
        </div>
      </Container>
    </div>
  )
}
